export const CAMPAIGN_MIN_BUDGET = 20;
export const CAMPAIGN_DEFAULT_MAX_BUDGET = 10000;
export const CAMPAIGN_MAX_BUDGET = 20000;
export const CAMPAIGN_MAX_BUDGET_INTERNAL = 25;
